"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListBox = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var ListBox_static_1 = require("./ListBox.static");
var ListBox_style_1 = __importDefault(require("./ListBox.style"));
function useListBox(_a) {
    var fetchMore = _a.fetchMore, groupedItems = _a.groupedItems, helperText = _a.helperText, items = _a.items, loading = _a.loading, noOptions = _a.noOptions, noOptionsText = _a.noOptionsText, popperRef = _a.popperRef;
    var _b = __read((0, react_1.useState)('40vh'), 2), height = _b[0], setHeight = _b[1];
    var itemValues = (0, react_1.useMemo)(function () { return (0, lodash_1.flatten)((0, lodash_1.values)(groupedItems)); }, [groupedItems]);
    var groupKeys = (0, react_1.useMemo)(function () { return (0, lodash_1.keys)(groupedItems); }, [groupedItems]);
    var headerText = (function () {
        if (noOptions) {
            return loading ? ListBox_static_1.localText.loading : noOptionsText;
        }
        if (helperText) {
            return helperText;
        }
        return undefined;
    })();
    var virtuosoStyle = {
        maxHeight: '40vh',
        height: items.length ? height : undefined,
    };
    // We cannot know the height of the virtuoso list before data is loaded/changed
    // therefore we need to imperatively tell popper to update it's calculations on each paint otherwise position is off
    (0, react_1.useLayoutEffect)(function () {
        var _a;
        (_a = popperRef.current) === null || _a === void 0 ? void 0 : _a.update();
    });
    return {
        classes: (0, ListBox_style_1.default)(),
        getGroupKey: function (index) { return groupKeys[index]; },
        getGroupedItem: function (index) { return itemValues[index]; },
        groupCounts: (0, react_1.useMemo)(function () { return (0, lodash_1.map)(groupedItems, function (items) { return items.length; }); }, [groupedItems]),
        handleEndReached: (0, react_1.useCallback)(function () { return void (fetchMore === null || fetchMore === void 0 ? void 0 : fetchMore()); }, [fetchMore]),
        handleHeightChange: setHeight,
        headerText: headerText,
        virtuosoStyle: virtuosoStyle,
    };
}
exports.useListBox = useListBox;
var logic = {
    useListBox: useListBox,
};
exports.default = logic;
